import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
// themes
import { colors } from 'themes'
// views
import { SearchRoundedIcon } from 'components/UI/PageSearch/views'
import { SearchIconWrapper, SearchWrapper as SearchWrapperOrigin } from 'themes/views/layouts'

// @ts-ignore
const SearchWrapper = styled(SearchWrapperOrigin)`
  && {
    align-items: center;
    border-radius: 25px;
    border: 2px solid ${colors.gray290};
    display: flex;
    flex: 1 1 0;
    flex-direction: row-reverse;
    margin: 0;
    max-width: 400px;
    min-width: 0;
    width: auto;

    div:nth-child(2) {
      margin: 0 8px 0 40px;
    }

    input {
      cursor: text;
    }
  }
`

const Search: React.FunctionComponent<any> = ({ handleInputChange, name }) => {
  return (
    <SearchWrapper>
      <SearchIconWrapper>
        <SearchRoundedIcon htmlColor={colors.black} />
      </SearchIconWrapper>
      <ReduxInput
        placeholder={'Search...'}
        name={name}
        handleInputChange={handleInputChange}
        disableUnderline
        inputColor={colors.gray320}
      />
    </SearchWrapper>
  )
}

export default Search
